import getLocaleMessages from '../utils/localesMessages';
import _each from 'lodash/each';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _merge from 'lodash/merge';
import {
	isSupportedVariable,
	parseTextAreaValue
} from './extraVariables';
import { BTN_FACTORY_MAX_PROGRAMS } from '../clientConstants';
import { normalizeNumber, formatCurrencyAsISOFormat } from '../utils/amountUtils';

const {
	required,
	invalidURL,
	insecureURL,
	emailIsRequired,
	invalidEmail,
	programs: {
		limitTen,
		atleastOne,
		invalidProgramSize
	},
	purpose,
	// presetAmount,
	unsupportedImageFormat
} = getLocaleMessages('buttons/fieldErrors');

const {
	error
} = getLocaleMessages('common/amount');

const MAX_TEXT_LENGTH = 127;

export function validate(values) {
	const errors = {};

	// Validation for buttonImageUrl
	if (values.usePaypalButtonStyle === 'no') {
		const buttonImageUrl = values.buttonImageUrl;

		if (!buttonImageUrl) {
			errors.buttonImageUrl = required;
		} else if (!isValidUrl(buttonImageUrl)) {
			errors.buttonImageUrl = invalidURL;
		}
	}

	if (!values.organizationName) {
		errors.organizationName = required;
	}

	if (!values.business) {
		errors.business = emailIsRequired;
	} else if (!isValidEmail(values.business)) {
		errors.business = invalidEmail;
	}

	if (!values.receiverCurrency) {
		errors.receiverCurrency = required;
	}

	if (values.amountType === 'fixed') {
		if (!values.amountValue || parseFloat(normalizeNumber(values.amountValue)) === 0) {
			errors.amountValue = required;
		}
	}
	
	let currencyParams = {
		currency: values.receiverCurrency,
		value: 1
	}
	if (values.amountType === 'merchant_recommended') {
		if (!values.merchantAmount1 || normalizeNumber(parseFloat(values.merchantAmount1)) < 1) {
			const minimumDonationError = error.minimumDonationUSShort.replace('{amount}', formatCurrencyAsISOFormat(currencyParams));
			errors.merchantAmount1 = minimumDonationError;
		}

		if (!values.merchantAmount2 || normalizeNumber(parseFloat(values.merchantAmount2)) < 1) {
			const minimumDonationError = error.minimumDonationUSShort.replace('{amount}', formatCurrencyAsISOFormat(currencyParams));
			errors.merchantAmount2 = minimumDonationError;
		}

		if (!values.merchantAmount3 || normalizeNumber(parseFloat(values.merchantAmount3)) < 1) {
			const minimumDonationError = error.minimumDonationUSShort.replace('{amount}', formatCurrencyAsISOFormat(currencyParams));
			errors.merchantAmount3 = minimumDonationError;
		}
	}

	// User has settingsLogoUrl but chose to not use it
	// This case logoUrl becomes "required"
	if (values.settingsLogoUrl && values.useSettingsLogo === 'no') {
		if (!isValidSecureUrl(values.logoUrl)) {
			errors.logoUrl = insecureURL;
		}
	}
	if (values.useSettingsLogo === 'no' && values.logoUrl && !isValidSecureUrl(values.logoUrl)) {
		errors.logoUrl = insecureURL;
	}

	if (values.useSettingsLogo === 'no' && values.logoUrl && isValidSecureUrl(values.logoUrl) && !isValidImageFormat(values.logoUrl)) {
		errors.logoUrl = unsupportedImageFormat;
	}

	if (values.cancelReturn && !isValidUrl(values.cancelReturn)) {
		errors.cancelReturn = invalidURL;
	}

	if (values.return && !isValidUrl(values.return)) {
		errors.return = invalidURL;
	}

	const extraVariablesError = validateExtraVariables(values.extraVariablesView)
	if (extraVariablesError) {
		errors.extraVariablesView = extraVariablesError;
	}

	// Check text field length
	if (values.purpose && byteLength(values.purpose) > MAX_TEXT_LENGTH) {
		errors.purpose = purpose.invalidPurposeSize;
	}

	if (values.itemNumber && byteLength(values.itemNumber) > MAX_TEXT_LENGTH) {
		errors.itemNumber = invalidProgramSize;
	}

	const programErrors = validatePrograms(values);
	if (!_isEmpty(programErrors)) {
		_merge(errors, programErrors);
	}

	return errors;
}


function isValidSecureUrl(url) {
	let urlRegex = /^((https|HTTPS):\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]%@!\$&'\(\)\*\+,;=.]+$/ // eslint-disable-line
	return urlRegex.test(url);
}

function isValidUrl(url) {
	let urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]%@!\$&'\(\)\*\+,;=.]+$/ // eslint-disable-line
	return urlRegex.test(url);
}

function isValidImageFormat(url) {
	let urlRegex = /\.(jpg|png|gif)$/
	return urlRegex.test(url);
}

function isValidEmail(email) {
	let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return emailRegex.test(email);
}

function validatePrograms(values) {
	const errors = {};
	if (values.listPrograms === 'no') {
		return;
	}

	if (values.newProgramName && byteLength(values.newProgramName) > MAX_TEXT_LENGTH) {
		errors.newProgramName = invalidProgramSize;
	}

	if (values.newProgramName && (values.programNames && values.programNames.length >= BTN_FACTORY_MAX_PROGRAMS)) {
		errors.newProgramName = limitTen;
	}

	if (_isEmpty(values.programNames)) {
		errors.newProgramName = atleastOne;
	}

	return errors;
}


function validateExtraVariables(extraVariables) {
	if (!extraVariables) {
		return null;
	}
	const variables = parseTextAreaValue(extraVariables);
	let unsupportedVariables = [];
	_each(variables, (variable) => {
		const key = _get(variable, 'name');
		if (key && !isSupportedVariable(key)) {
			unsupportedVariables.push(key)
		}
	})

	return unsupportedVariables.join(' ');
}

function byteLength(str) {
	// returns byte length of an utf8 string
	let byteCount = str.length;

	for (let i = str.length - 1; i >= 0; i--) {
		let code = str.charCodeAt(i);
		
		if (code > 0x7f && code <= 0x7ff) {
			byteCount++;
		} else if (code > 0x7ff && code <= 0xffff) { 
			byteCount += 2;
		}
		if (code >= 0xDC00 && code <= 0xDFFF) {
			i--; 
		}
	}
	return byteCount;
}



// WEBPACK FOOTER //
// ./buttons/lib/clientValidator.js